import { useCancelPolicy } from "@/components/features/_hooks/use-cancel-policy/use-cancel-policy";

import { useProductDayTripPlanFormModelContext } from "../../../../context";

export const useDayTripPlanCancelPolicy = () => {
	const { viewModel, onSetViewModel } = useProductDayTripPlanFormModelContext();
	const { cancelPolicy } = viewModel;

	return useCancelPolicy({ cancelPolicy, onSetViewModel });
};
